export default {
  apiKey: "AIzaSyAlc0oSF_Ng3Gsg7v_L6b0ghOhzqC89U90",
  authDomain: "evernote-e077e.firebaseapp.com",
  databaseURL: "https://evernote-e077e.firebaseio.com",
  projectId: "evernote-e077e",
  storageBucket: "evernote-e077e.appspot.com",
  messagingSenderId: "333330020976",
  appId: "1:333330020976:web:54cf720ea4e6db7b3b52b5",
  measurementId: "G-9YCRSXNSW8",
};
